import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CrowdFlowsObservedStore, CrowdFlowObservedState } from './crowd-flows-observed.store';

@Injectable({ providedIn: 'root' })
export class CrowdFlowsObservedQuery extends QueryEntity<CrowdFlowObservedState> {

  constructor(protected store: CrowdFlowsObservedStore) {
    super(store);
  }

}
